angular.module('signalview.TOOLTIPS').constant('PLOT_OPTION_STRINGS', {
    DISPLAY_UNITS:
        'Text that will appear alongside your values. <a target="_blank" href="https://quickdraw.splunk.com/redirect/?product=Observability&location=learnmore.chart&version=current">Learn more</a>',
    PLOT_COLOR_METRIC:
        'Specifies the color of this plot, overriding the selected chart color scheme.',
    PLOT_COLOR_EVENT: 'Specifies the event marker color for this event.',
    VISUALIZATION_TYPE:
        'Specifies whether plot is displayed as line, area, column, or histogram. Overrides selected chart type.',
});
